var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 10.9998V5.31335C23 3.96177 23 3.28598 22.7153 2.87068C22.4665 2.50783 22.0813 2.26134 21.6476 2.18754C21.1512 2.10307 20.5376 2.38626 19.3104 2.95265L4.8959 9.60552C3.80145 10.1107 3.25422 10.3632 2.85342 10.7549C2.49909 11.1012 2.22863 11.5239 2.06269 11.9908C1.875 12.5188 1.875 13.1215 1.875 14.3269V22.3748M23.8125 21.5623H23.8288M1.875 16.1998L1.875 26.9248C1.875 28.7449 1.875 29.655 2.22923 30.3502C2.54082 30.9618 3.038 31.459 3.64953 31.7705C4.34474 32.1248 5.25483 32.1248 7.075 32.1248H25.925C27.7452 32.1248 28.6553 32.1248 29.3505 31.7706C29.962 31.459 30.4592 30.9618 30.7708 30.3502C31.125 29.655 31.125 28.7449 31.125 26.9248V16.1998C31.125 14.3796 31.125 13.4695 30.7708 12.7743C30.4592 12.1628 29.962 11.6656 29.3505 11.354C28.6553 10.9998 27.7452 10.9998 25.925 10.9998L7.075 10.9998C5.25483 10.9998 4.34474 10.9998 3.64953 11.354C3.038 11.6656 2.54082 12.1628 2.22923 12.7743C1.875 13.4695 1.875 14.3796 1.875 16.1998ZM24.625 21.5623C24.625 22.011 24.2612 22.3748 23.8125 22.3748C23.3638 22.3748 23 22.011 23 21.5623C23 21.1135 23.3638 20.7498 23.8125 20.7498C24.2612 20.7498 24.625 21.1135 24.625 21.5623Z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.aa26e7f7d8eb453805f84c8a0994df13.svg";
export { ForwardRef as ReactComponent };